import PropTypes from 'prop-types';
import React from 'react';
import { Button, Select } from '@ipc/ipc-components';
import { Link } from '@ipc/ipc-core';
import FormLabel from '@material-ui/core/FormLabel';

import { TopButtonsWrapper, AppContentInner, AppContentTitle } from '../../styles';
import { primaryButton } from '../../styles/themes';
import AlaTableView from '../../components/custom/AlaTableView';

import { ALA_OPTIONS } from './constants';
import { useDefaultAla } from './hooks';
import { LabelText, ButtonsWrapper, ViewAlaButtonWrapper } from './styles';

function DefaultAla({ successNotification }) {
  const [level, updateLevel, loading, updateAlaLevel] = useDefaultAla();

  const changeHandler = async (newLevel) => {
    await updateLevel(newLevel);
  };

  const submitHandler = async (newLevel) => {
    await updateAlaLevel(newLevel);
    successNotification('Default ALA View Level was updated!', 500);
  };

  return (
    <AppContentInner>
      <AppContentTitle>ALA Default View Level</AppContentTitle>
      <TopButtonsWrapper>
        <ViewAlaButtonWrapper>
          <AlaTableView />
        </ViewAlaButtonWrapper>
      </TopButtonsWrapper>
      <form className="Form">
        <div className="FormRow">
          <div className="FormRowInline">
            <FormLabel>
              <LabelText>
              The ALA level you select will determine the receptacle you see in the pre-settlement records. One will only see receptacles above and inclusive of the selected ALA level.
              </LabelText>
              <Select
                options={ALA_OPTIONS}
                value={level}
                className="Input SingleSelect InputSmall"
                onChange={changeHandler}
                name="level"
              />
            </FormLabel>
          </div>
        </div>
        <ButtonsWrapper>
          <Link to="/">
            <Button>
              Cancel
            </Button>
          </Link>
          <Button onClick={submitHandler} disabled={loading} theme={primaryButton} data-testid="submit-action">
              Apply
          </Button>
        </ButtonsWrapper>
      </form>
    </AppContentInner>
  );
}

DefaultAla.propTypes = {
  successNotification: PropTypes.func,
};

export default DefaultAla;
